/**
 * ToastProvider — совместимая заглушка.
 * Отображение уведомлений управляется напрямую через src/services/toast.ts
 * без инлайн-стилей (CSP-совместимо).
 */
export function ToastProvider() {
  return null;
}
